// import { routes } from "defs";
import { EventImageCodes } from 'defs/events';
import { getTargetFromFactory /* TargetTypes, TargetActions */ } from 'defs/notifications';
import { TargetTypes } from 'defs/notifications';
import appConfig from 'helper/mapBackendConfig';

const targets = {
	[EventImageCodes.AppStore]: {
		// No buttons specified, only text/image overlay
	},
	[EventImageCodes.Newsletter]: {
		primary: {
			cabllackId: 'subscribe-newsletter',
			type: TargetTypes.ExternalHref,
			value: {
				href: appConfig.env.migrosImpulsNewsletterPage.href,
			},
		},
		secondary: {
			type: TargetTypes.Close,
		},
	},
};

export const get = (key: string) => getTargetFromFactory(targets as any, key);

export default targets;
